export default __webpack_public_path__ + "static/media/fav.6de9c52f.ico";